module.exports = __webpack_public_path__ + "img/phone-list-perso.7d1a4564.webp";